<template>
  <footer>
    <b-nav>
      <template v-for="item in sections">
        <b-nav-item :key="item.title" :href="item.url" :target="'_blank'" :class="item.class + ' icon'">{{ item.title }}</b-nav-item>
      </template>
    </b-nav>
    <div class="one-pager-footer">
      <p>Care is improving. <a href="/static/AHCA_RepCampaign_Site_One-pager.pdf" onclick="trackOutboundLink('/static/AHCA_RepCampaign_Site_One-pager.pdf'); return false;">Download our resource</a> to see how.</p>
    </div>
    <div class="branding">
      <p>Created with care by</p>
      <img src="/static/ahca.svg" class="logo" />
    </div>
    <div class="copyright">Copyright 2018 American Health Care Association</div>
  </footer>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Footer',
  data () {
    return {
      sections: this.content.footerNav
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../_variables.scss';

footer {
  background: $black;
  padding: 3rem 0 0;
  border-top: 2px solid $white;
  color: $white;
  text-align: center;
  @media (min-width: 768px) {
    z-index: 2;
    position: relative;
    text-align: left;
    padding: 2rem 0 0;
    .branding {
      display: inline-block;
      margin-left: 1rem;
    }
  }
  ul.nav {
    text-align: center;
    display: block;
    @media (min-width: 768px) {
      float: right;
      margin-top: .75rem;
    }
    li {
      display: inline-block;
      margin: 0 1rem 2rem;
      @media (min-width: 768px) {
        margin: 0 1rem;
      }
    }
    a.nav-link {
      margin: -1rem;
    }
  }
  .icon {
    text-indent: -9999px;
    display: inline-block;
    box-sizing: border-box;
    padding: 22px;
    height: 44px;
    width: 44px;
    &.facebook {
      background: url(../../static/facebook.svg) no-repeat;
      background-size: 90%;
      background-position: 2px 2px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover {
        background-size: 100%;
        background-position: 0 0;
      }
    }
    &.twitter {
      background: url(../../static/twitter.svg) no-repeat;
      background-size: 90%;
      background-position: 2px 2px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover {
        background-size: 100%;
        background-position: 0 0;
      }
    }
    &.linkedin {
      background: url(../../static/linkedin.svg) no-repeat;
      background-size: 90%;
      background-position: 2px 2px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover {
        background-size: 100%;
        background-position: 0 0;
      }
    }
  }
  p {
    margin-bottom: .5rem;
  }
  .logo {
    max-width: 158px;
  }
  .copyright {
    margin-top: 2rem;
    background: $white;
    color: $black;
    width: 100%;
    padding: .5rem 0;
    text-align: center;
  }
  .one-pager-footer {
    position: relative;
    left: auto;
    top: auto;
    width: 100%;
    margin-left: 0;
    margin-bottom: 20px;
    @media all and (min-width: 768px) {
      position: absolute;
      left: 50%;
      top: 55px;
      text-align: center;
      width: 420px;
      margin-left: -210px;
    }
    a {
      color: $white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue